/*
 * ⚠️ `#fff` ЗДЕСЬ ОСОЗНАННО, разбор — в `MessengerAvatar.tsx`: это БРЕНД-иконка (лого WhatsApp/
 * Telegram), и белое на фирменном цвете — часть самого лого, а не наш выбор краски. Подмена на
 * `var(--on-accent)` нарисовала бы в тёмной теме ТЁМНЫЙ значок WhatsApp. Макет фиксирует то же
 * («бренд-иконка — белая осознанно», docs/reference/phase-2-mockup.md:247).
 *
 * Не переноси сюда правку `--on-accent` из аватаров-инициалов и галки события: там красится наш
 * текст на нашей плитке, здесь — чужое лого. Литерал объявлен поимённо в `tools/contrast.mjs`
 * (`ЛИТЕРАЛЫ_ПО_ДЕЛУ`) — без этой записи скан литералов роняет сборку.
 */
.root {
  display: grid;
  place-items: center;
  flex-shrink: 0;
  background: var(--tint);
  color: #fff;
}

/* Дефект макета (см. комментарий в MessengerAvatar.tsx) — на плитке Email побеждал бы белый
   поверх почти белого --sunk. Берём осмысленное объявление вместо него. */
.email {
  color: var(--ink-2);
}
